export const MIX = {
  TURNSTILE_SITE_KEY: process.env.MIX_TURNSTILE_SITE_KEY,
  TR4CTOR_WEBHOOKS_URL: process.env.MIX_TR4CTOR_WEBHOOKS_URL,
  TR4CTOR_WEBHOOKS_TOKEN: process.env.MIX_TR4CTOR_WEBHOOKS_TOKEN
}
